/* One owl-carousel init for the whole theme.
   Every .owl-carousel element carries its options in data-carousel (JSON):
     { "autoplay": bool, "nav": bool, "dots": bool, "loop": bool,
       "items": { "<breakpoint-px>": <visible count> } }
   Defaults: loop and nav on, dots and autoplay off.
   Carousels inserted later (product-recommendations via fetch, editor
   shopify:section:load) are initialised too, via a MutationObserver. */
(function () {
  function toResponsive(items) {
    var r = {};
    Object.keys(items).forEach(function (bp) { r[bp] = { items: items[bp] }; });
    return r;
  }
  function initOne(el) {
    if (el.classList.contains('owl-loaded')) return;
    var o = {};
    try { o = JSON.parse(el.getAttribute('data-carousel') || '{}'); } catch (e) { o = {}; }
    var opts = { loop: o.loop !== false, nav: o.nav !== false, dots: !!o.dots, autoplay: !!o.autoplay };
    if (o.items) opts.responsive = toResponsive(o.items);
    /* owl's default nav buttons carry role="presentation", not allowed on <button> */
    opts.navElement = 'button type="button"';
    var $el = window.jQuery(el);
    if (el.tagName === 'UL' || el.tagName === 'OL') {
      $el.on('initialized.owl.carousel refreshed.owl.carousel', function () { keepListSemantics(el); });
    }
    $el.owlCarousel(opts);
  }
  /* owl moves each <li> into div.owl-stage > div.owl-item and appends the nav inside the list.
     The list role moves to the stage, the wrappers become role="none", so the <li>s stay list items
     and the nav buttons end up outside the list. */
  function keepListSemantics(el) {
    el.setAttribute('role', 'none');
    var stage = el.querySelector(':scope > .owl-stage-outer > .owl-stage');
    if (stage) stage.setAttribute('role', 'list');
    el.querySelectorAll(':scope > .owl-stage-outer > .owl-stage > .owl-item').forEach(function (item) {
      item.setAttribute('role', 'none');
    });
  }
  function initAll(root) {
    (root || document).querySelectorAll('.owl-carousel:not(.owl-loaded)').forEach(initOne);
  }
  var tries = 0;
  function start() {
    if (!(window.jQuery && window.jQuery.fn && window.jQuery.fn.owlCarousel)) {
      if (tries++ < 100) setTimeout(start, 50);
      return;
    }
    initAll();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { initAll(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
